// extracted by mini-css-extract-plugin
module.exports = {"buttonsContainer":"OnGoingPaymentBox_buttonsContainer__3Xz-F","resendInfoText":"OnGoingPaymentBox_resendInfoText__2NJOz"};